export type UserPlan = {
  name: string;
  tier: 'free' | 'pro' | 'enterprise';
};

// TODO: replace with real implementation
export async function hasActivePlan(): Promise<boolean> {
  // Toggle this flag during dev to simulate plan presence
  return true;
}

// TODO: replace with real implementation
export async function getUserPlan(): Promise<UserPlan | null> {
  return { name: 'Pro', tier: 'pro' };
}

export function startNewCategorization(): void {
  // Placeholder action. Wire to modal or route once ready.
  alert('New categorization flow coming soon.');
} 